import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import CurrencyInput from 'react-currency-input';
import moment from 'moment';
import DriverExpenseAccountAuditTrailBreakdown from
    './driver-expense-account-audit-trail-breakdown.jsx';

export default class DriverExpenseAccount extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      text: props.initialValue || 'placeholder',
      data: props.data || null,
      isLoading: false,
      driver_expense_account_limit_in_pence: props.data.driver.expense_account.expense_account_limit_in_pence || null,
      driver_expense_account_current_total_value_in_pence: props.data.driver.expense_account.expense_account_current_total_value_in_pence || null,
      addRemoveFundsValueInPence: '',
      addRemoveFundsValueFormatted: '',
      reference: '',
    };

    let that = this;
    let expenseAccountId = this.state.data.driver.expense_account.id;

     Echo.channel('driver-expense-account-'+expenseAccountId)
    .listen('DriverExpenseAccountChanged', (e) => {
        that.getExpenseAccount();
    });
    this.getExpenseAccount();

    this.expenseLimit_onBlur = this.expenseLimit_onBlur.bind(this);
    this.expenseTotalCurrentValue_onBlur = this.expenseTotalCurrentValue_onBlur.bind(this);

    this.handleReferenceChange = this.handleReferenceChange.bind(this);
    this.handleAddRemoveFundsValueInPenceChange = this.handleAddRemoveFundsValueInPenceChange.bind(this);
  }

  expenseLimit_onBlur() {
    this.changeExpenseAccountLimit();
  }

  expenseTotalCurrentValue_onBlur() {
    this.changeExpenseAccountCurrentTotal();
  }

  getExpenseAccount() {
    let that = this;
    $.ajax({
      url: '/api/v1/portal/drivers/expense-accounts/'+this.props.data.driver.expense_account.id,
      data: {api_token: window.api_token},
      cache: false
    })
    .done(function(driverExpenseAccountJson) {
      that.setState({
        data: driverExpenseAccountJson,
        isLoading: false,
        driver_expense_account_limit_in_pence: driverExpenseAccountJson.driver.expense_account.expense_account_limit_in_pence,
        driver_expense_account_current_total_value_in_pence: driverExpenseAccountJson.driver.expense_account.expense_account_current_total_value_in_pence,
      });
    });
  }

  handleExpenseAccountAuditTrailBreakdownButtonClicked(expenseAccountId) {
    let driverExpenseAccountAuditTrailBreakdownModal = $(
      '#driver-expense-account-audit-trail-breakdown-modal'
    );

    driverExpenseAccountAuditTrailBreakdownModal.data(
      'expense-account-id', expenseAccountId
    );
    driverExpenseAccountAuditTrailBreakdownModal.modal(
      'show'
    );

    if (document.getElementById(
      'react-component-g4-logistics-portal-driver-expense-account-audit-trail-breakdown'
    )) {
      ReactDOM.unmountComponentAtNode(
        document.getElementById(
          'react-component-g4-logistics-portal-driver-expense-account-audit-trail-breakdown'
        )
      );
      ReactDOM.render(
        <DriverExpenseAccountAuditTrailBreakdown
          expense_account_id={expenseAccountId}
        />,
        document.getElementById(
          'react-component-g4-logistics-portal-driver-expense-account-audit-trail-breakdown'
        )
      );
    }
  }

  handleFundsAddedToExpenseAccount() {
    let reference = this.state.reference;
    let value = this.state.addRemoveFundsValueInPence;

    $.ajax({
      url: "/api/v1/portal/drivers/expense-accounts/"+this.state.data.driver.expense_account.id+"/add-funds",
      data: {
        api_token: window.api_token,
        reference: reference,
        value: value
      },
      cache: false,
      method: 'post',
    })
    .done(function(data) {
    //  alert('cancelled');
    });
  }

  handleFundsRemovedFromExpenseAccount() {
    let reference = this.state.reference;
    let value = this.state.addRemoveFundsValueInPence;

    $.ajax({
      url: "/api/v1/portal/drivers/expense-accounts/"+this.state.data.driver.expense_account.id+"/remove-funds",
      data: {
        api_token: window.api_token,
        reference: reference,
        value: value
      },
      cache: false,
      method: 'post',
    })
    .done(function(data) {
    //  alert('cancelled');
    });
  }

  changeExpenseAccountLimit() {
    //let formattedValue = this.state.driver_expense_account_limit_value_formatted;
    let value = this.state.driver_expense_account_limit_in_pence;
    let reference = this.state.reference;

    if (value === this.state.data.driver.expense_account_limit_in_pence) {
      return null;
    }

    let changeExpenseAccountLimit = confirm('change limit from '+
      this.state.data.driver.expense_account.expense_account_limit_in_pence +
      ' to '+ (value) + '?'
    );

    if (changeExpenseAccountLimit) {
      $.ajax({
        url: "/api/v1/portal/drivers/expense-accounts/"+this.state.data.driver.expense_account.id+"/change-expense-account-limit",
        data: {
          api_token: window.api_token,
          expense_account_limit_in_pence: (value),
          reference: reference,
        },
        cache: false,
        method: 'post',
      })
      .done(function(data) {
      //  alert('cancelled');
      });
    }
    else {
      this.setState({
        driver_expense_account_limit_in_pence: (this.state.data.driver.expense_account.expense_account_limit_in_pence)
      });
    }
  }

  changeExpenseAccountCurrentTotal() {
   // let formattedValue = this.state.driver_expense_account_current_total_value_formatted;
    let value = this.state.driver_expense_account_current_total_value_in_pence;
    let reference = this.state.reference;

    if (value === this.state.data.driver.driver_expense_account_current_total_value_in_pence) {
      return null;
    }

    let changeExpenseAccountCurrentTotalValue = confirm(
      'change current total value from ' +
      this.state.data.driver.expense_account.expense_account_current_total_value_in_pence +
      ' to '+ (value) + '?'
    );

    if (changeExpenseAccountCurrentTotalValue) {
      $.ajax({
        url: "/api/v1/portal/drivers/expense-accounts/"+this.state.data.driver.expense_account.id+"/change-expense-account-current-total-value",
        data: {
          api_token: window.api_token,
          expense_account_current_total_value_in_pence: (value),
          reference: reference,
        },
        cache: false,
        method: 'post',
      })
      .done(function(data) {
      //  alert('cancelled');
      });
    }
    else {
      this.setState({
        driver_expense_account_current_total_value_in_pence: (this.state.data.driver.expense_account.expense_account_current_total_value_in_pence)
      });
    }
  }

  handleReferenceChange(e) {
    this.setState({
      reference: e.target.value,
    });
  }

  handleAddRemoveFundsValueInPenceChange(e) {
    this.setState({
      addRemoveFundsValue: e.target.value,
    });
  }

  render() {
    let indicateIfAccountLimitExceeded = '';
    if (this.state.isLoading === false) {
      let currentTotalIsLessThanLimit = (
        this.state.driver_expense_account_current_total_value_in_pence <
        this.state.driver_expense_account_limit_in_pence
      );

      if (currentTotalIsLessThanLimit) {
        indicateIfAccountLimitExceeded = 'expense-account-limit-exceeded'
      }
      if (this.state.data.is_driver_sick) {
        indicateIfAccountLimitExceeded += ' is-driver-sick'
      }
    }
    let momentFormatString = 'ddd Do MMM YYYY @ h:mm:ssa';

    return(
      <div className="driver-expense-account-container">
      {
        (this.state.isLoading) ?
        (<div className="loading-box"><span className="add-loading-text"><i className="fa fa-spinner fa-pulse"></i></span></div>) :

        <div className={"row "+indicateIfAccountLimitExceeded}>
          <div className="col-md-2 expense-account-user-image-column">
            <img src={"/user-images/"+this.state.data.id} />
          </div>

          <div className="col-md-2 expense-account-user-full-name-column">
            <div>
              <h5>{this.state.data.first_name} {this.state.data.last_name}</h5>
              <a href={"/portal-admin/users/view/"+this.state.data.id} className="btn btn-sm btn-light" type="button">User Account</a><br />
              <a href={"/drivers/view/"+this.state.data.driver.id} className="btn btn-sm btn-light" type="button">Driver Account</a><br />
              <a className="btn btn-sm btn-light text-left" type="button"
                  onClick={() => {this.handleExpenseAccountAuditTrailBreakdownButtonClicked(this.state.data.driver.expense_account.id)}}
                  >Expense Account<br />Audit Trail Breakdown</a>
            </div>
          </div>

          <div className="col-md-8">
            <div className="row">
              <div className="col-md-4">
                <p>Account Limit:<br />
                <CurrencyInput value={this.state.driver_expense_account_limit_in_pence/100}
                prefix={'£'}
                type='text'
                allowNegative={true}
                className="form-control form-control-lg form-control-currency"
                onChangeEvent={
                  (event, maskedValue, floatValue) => {
                    this.setState({
                      driver_expense_account_limit_in_pence: (floatValue*100),
                      driver_expense_account_limit_value_formatted: maskedValue,
                    });

                  }
                }
                onBlur={this.expenseLimit_onBlur}
                 />
                Last updated:<br />
                <em>{moment(this.state.data.driver.expense_account.account_limit_updated_at).format(momentFormatString)}</em>
                </p>
                </div>
                <div className="col-md-4">
                <p>Account Current Total:<br />
                <CurrencyInput value={this.state.driver_expense_account_current_total_value_in_pence/100}
                prefix={'£'}
                type='text'
                allowNegative={true}
                className="form-control form-control-lg form-control-currency"
                onChangeEvent={
                  (event, maskedValue, floatValue) => {
                    this.setState({
                      driver_expense_account_current_total_value_in_pence: (floatValue*100),
                      driver_expense_account_current_total_value_formatted: maskedValue,
                    });
                  }
                }
                onBlur={this.expenseTotalCurrentValue_onBlur} />
                Last updated:<br />
                <em>{moment(this.state.data.driver.expense_account.current_total_value_updated_at).format(momentFormatString)}</em>
                </p>


                </div>

                <div className="col-md-4">
                <p className="driver-expense-account-add-remove-title">Add/Remove recorded funds:</p>
                <div className="input-group">
                <div className="input-group-append">
                <CurrencyInput type="text" name="funds" className="form-control form-control-lg form-control-currency"
                       value={this.state.addRemoveFundsValueInPence/100} prefix={'£'}
                       type='text'
                       allowNegative={true}
                       className="form-control form-control-lg form-control-currency driver-expense-account-add-remove-funds-input"
                       onChangeEvent={
                         (event, maskedValue, floatValue) => {
                           this.setState({
                             addRemoveFundsValueInPence: (floatValue*100),
                             addRemoveFundsValueFormatted: maskedValue,
                           });
                         }
                       }
                       onBlur={this.addRemoveFunds_onBlur}
               /><button onClick={() => {this.handleFundsAddedToExpenseAccount()}}
                          className="btn btn-lg btn-success">+</button><button
                          onClick={() => {this.handleFundsRemovedFromExpenseAccount()}}
                          className="btn btn-lg btn-danger">-</button>
                </div>
                </div>
                <div>
                  <input type="text" name="add_remove_funds_to_expense_account_reference" value={this.state.reference}
                         onChange={this.handleReferenceChange} className="form-control form-control-lg"
                         placeholder="REFERENCE" />
                </div>
              </div>
            </div>
          </div>
        </div>
      }
      </div>
    )
  }
}
